export const DISEASES = {
    TIEN_DAI_THAO_DUONG: "Tiền đái tháo đường",
    DAI_THAO_DUONG_TIP_1: "Đái tháo đường típ 1",
    DAI_THAO_DUONG_TIP_2: "Đái tháo đường típ 2",
    DAI_THAO_DUONG_THAI_KI: "Đái tháo đường thai kì",
    TANG_HUYET_AP: "Tăng huyết áp",
    BEO_PHI: "Béo phì",
    KHAC: "Khác",
};

export const DISEASES_ENG = {
  HasSymptom: "Tiền đái tháo đường",
  TypeOne: "Đái tháo đường típ 1",
  TypeTwo: "Đái tháo đường típ 2",
  Gestational: "Đái tháo đường thai kỳ",
  Hypertension: "Tăng Huyết Áp",
  Fat: "Béo Phì",
  Other: "Khác",
};


export const ONBOARDING = {
    ID:"350a3050-c0f7-11ef-b57a-03ea338ae610"
}

// Khách hàng không dùng nhóm Zalo (BE lưu đúng chuỗi này trong zaloGroupId)
export const NO_ZALO_GROUP = 'NO_ZALO_GROUP';

export function getNameDisease(value) {
  var result = DISEASES_ENG[value];
  return result;
}

